/* eslint react/prop-types: off */
import React from 'react'

const Information = ({ fieldsToRender }) => (
  <div className="mb-10">
    <table className="">
      {fieldsToRender.map(({ name, value }, index) => (
        <tr className={index % 2 && 'bg-gray-50'} key={name}>
          <td className="border border-gray-200 p-2 w-1/2">{name}</td>
          <td className="border border-gray-200 p-2">{value}</td>
        </tr>
      ))}
    </table>
  </div>
)

export default Information
